module.exports = __webpack_public_path__ + "static/media/newzealand.24740e33.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/panoramas/newzealand.JPG
// module id = 264
// module chunks = 0